export default __webpack_public_path__ + "static/media/Size6.a404e1fa.png";